/* eslint-disable prettier/prettier */
import React from 'react';
import MainLayout from '../Layouts/Mainlayout';
import RoleList from './RoleList';

export default function Roles(): JSX.Element {
  return (
    <div className="flex flex-row justify-start">
      <MainLayout>
        <RoleList />
      </MainLayout>
    </div>
  );
}
